import { render, staticRenderFns } from "./kertaskerja.vue?vue&type=template&id=3a913c90"
import script from "./kertaskerja.vue?vue&type=script&lang=js"
export * from "./kertaskerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports